// domain/mappers/cajaSesion.mapper.js


// domain/mappers/cajaSesionFromDB.mapper.js
import { CajaSesion } from "../entities/CajaSesion.js";

export function mapCajaSesionFromDB(row) {
  if (!row) return null;

  return new CajaSesion({
     id_sesion: row.id_sesion,            // 👈 camelCase
    fecha_apertura: row.fecha_apertura,
    fecha_cierre: row.fecha_cierre,
    id_usuario_apertura: row.id_usuario_apertura,
    id_usuario_cierre: row.id_usuario_cierre,
    saldo_inicial: row.saldo_inicial,
    saldo_final: row.saldo_final,
    estado: row.estado,
    punto: row.punto,
    observaciones: row.observaciones,
  });
}

export function cajaSesionToJSON(cajaSesion) {
  if (!cajaSesion) return null;

  return {
    id: cajaSesion.id,
    fecha_apertura: cajaSesion.fechaApertura,
    fecha_cierre: cajaSesion.fechaCierre,
    id_usuario_apertura: cajaSesion.usuarioAperturaId,
    id_usuario_cierre: cajaSesion.usuarioCierreId,
    saldo_inicial: cajaSesion.saldoInicial,
    saldo_final: cajaSesion.saldoFinal,
    estado: cajaSesion.estado,
    punto: cajaSesion.punto,
    observaciones: cajaSesion.observaciones,
  };
}


// domain/mappers/cajaSesion.mapper.js
export function cajaSesionToXML(cajaSesion) {
  if (!cajaSesion) return "";

  return `
    <cajaSesion>
      <id>${cajaSesion.id}</id>
      <fechaApertura>${cajaSesion.fechaApertura}</fechaApertura>
      <fechaCierre>${cajaSesion.fechaCierre ?? ""}</fechaCierre>
      <usuarioAperturaId>${cajaSesion.usuarioAperturaId}</usuarioAperturaId>
      <usuarioCierreId>${cajaSesion.usuarioCierreId ?? ""}</usuarioCierreId>
      <saldoInicial>${cajaSesion.saldoInicial}</saldoInicial>
      <saldoFinal>${cajaSesion.saldoFinal ?? ""}</saldoFinal>
      <estado>${cajaSesion.estado}</estado>
      <punto>${cajaSesion.punto}</punto>
      <observaciones>${cajaSesion.observaciones ?? ""}</observaciones>
    </cajaSesion>
  `.trim();
}


